import {
  GET_SALESHISTORY,
  GET_SALESHISTORY_SUCCESS,
  GET_SALESHISTORY_FAIL,
  DELETE_SALESHISTORY,
  DELETE_SALESHISTORY_SUCCESS,
  DELETE_SALESHISTORY_FAIL,
  UPDATE_SALESHISTORY,
  UPDATE_SALESHISTORY_SUCCESS,
  UPDATE_SALESHISTORY_FAIL,
  ADD_NEW_SALESHISTORY,
  ADD_SALESHISTORY_SUCCESS,
  ADD_SALESHISTORY_FAIL,
  SALESHISTORY_LOADING,
  SALESHISTORY_RESET,
} from "./actionType";

export const resetSalesHistoryState = (actionType) => ({
  type: SALESHISTORY_RESET,
  payload: { actionType },
});

export const getSalesHistorySuccess = (actionType, data) => ({
  type: GET_SALESHISTORY_SUCCESS,
  payload: { actionType, data },
});

export const getSalesHistoryFail = (actionType, error) => ({
  type: GET_SALESHISTORY_FAIL,
  payload: { actionType, error },
});

export const getSalesHistory = data => ({
  type: GET_SALESHISTORY,
  payload: data,
});

export const getSalesHistoryLoading = () => ({
  type: SALESHISTORY_LOADING
});

export const deleteSalesHistory = data => ({
  type: DELETE_SALESHISTORY,
  payload: data,
});

export const deleteSalesHistorySuccess = data => ({
  type: DELETE_SALESHISTORY_SUCCESS,
  payload: data,
});

export const deleteSalesHistoryFail = error => ({
  type: DELETE_SALESHISTORY_FAIL,
  payload: error,
});

export const updateSalesHistory = data => ({
  type: UPDATE_SALESHISTORY,
  payload: data,
});

export const updateSalesHistoryFail = error => ({
  type: UPDATE_SALESHISTORY_FAIL,
  payload: error,
});

export const updateSalesHistorySuccess = data => ({
  type: UPDATE_SALESHISTORY_SUCCESS,
  payload: data,
});

export const addNewSalesHistory = data => ({
  type: ADD_NEW_SALESHISTORY,
  payload: data,
});

export const addSalesHistorySuccess = data => ({
  type: ADD_SALESHISTORY_SUCCESS,
  payload: data,
});

export const addSalesHistoryFail = error => ({
  type: ADD_SALESHISTORY_FAIL,
  payload: error,
});